import _ from "lodash"

/**
 * Disable navigators
 * See: https://www.highcharts.com/docs/stock/navigator
 * See API doc: https://api.highcharts.com/highstock/navigator
 * @param chartOpts
 * @returns {*}
 */
export default function disableNavigator(chartOpts) {
  _.set(chartOpts, "navigation.enabled", false)
  _.set(chartOpts, "navigator.enabled", false)
  return chartOpts
}
